<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Seguimiento de entregas a clientes. 
                Muestra entregas pendientes y realizadas, 
                con fechas y evidencias. Úsalo para verificar 
                cumplimiento y resolver atrasos.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Entregas
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Lista, procesa y sincroniza las <b>entregas</b> destinada a los <b>socios de negocio</b> de forma individual y/o bloque.
        </div>
      </div>
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Listado de Entrega</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
            [selectedCustomerType]="selectedCustomerType" 
            [showStatus]="[StatusEnum.ACTIVE,StatusEnum.INACTIVE,StatusEnum.ORDER_IN_PROGRESS,StatusEnum.ORDER_APPROVED,StatusEnum.ORDER_REJECTED,StatusEnum.ORDER_PARTIAL_APPROVED, StatusEnum.ORDER_DELIVERED, StatusEnum.ORDER_PARTIAL_DELIVERED,StatusEnum.ORDER_DELIVERY_REJECTED]"
            [showERPStatus]="[OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_CREATED, OrderStatusERPEnum.ORDER_ERROR, OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_ERROR_ERP]" 
            [showCustomerType]="['BPT9002','BPT9001','BPT0001']" (selectionFilterApply)="getList()">
          </app-status-filters> 
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- <button *canPermissionsOnly="PERMISSIONS.EXPORT_IMPORT" mat-stroked-button color="primary" (click)="onExportButtonPressed()" matTooltip="Exportar">
              <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
              <span>Exportar</span>
          </button> -->
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>

          <button *canPermissionsOnly="PERMISSIONS.UPDATE_TIME" mat-icon-button color="primary"
            matTooltip="{{!this.showInterval ? 'Activar tiempo automático' : 'Desactivar tiempo automático'}}"
            (click)="openInterval(this.showInterval = !this.showInterval)">
            <mat-icon>{{ this.showInterval ? 'timer' : 'timer_off'}}</mat-icon>
          </button>

          <button [disabled]="(!(PERMISSIONS.SYNC | hasPermission)) || (!isGlobalSynchronizeAvailable)" mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Sincronizar"
            (click)="synchronizeOrders(null)">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMenu">
              <span>Estados</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusERPMenu">
              <span>Estados ERP</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="customerMenu">
              <span>Cliente</span>
            </button>
          </mat-menu>

          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(65, 106, 218)"></mat-icon>
              <span>Activo</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(141, 19, 19)"></mat-icon>
              <span>Anulado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:play-circle" style="color:rgb(236, 199, 58)"></mat-icon>
              <span>En progreso</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Aprobado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Rechazado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="mat_solid:checklist_rtl" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Entregado completamente al cliente</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="mat_solid:check" style="color:rgb(255, 136, 0)"></mat-icon>
              <span>Entregado parcialmente al cliente</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="mat_solid:indeterminate_check_box" style="color:rgb(255, 55, 0)"></mat-icon>
              <span>No entregado al cliente</span>
            </button>
            <button mat-menu-item>
              <mat-icon
                svgIcon="heroicons_solid:play-circle"
                style="color: rgb(236, 199, 58)"
              ></mat-icon>
              <span>En proceso de aprobación</span>
            </button>
            <button mat-menu-item>
              <mat-icon
                svgIcon="heroicons_solid:exclamation-circle"
                style="color: rgb(236, 199, 58)"
              ></mat-icon>
              <span>En espera de aprobación</span>
            </button>
            <button mat-menu-item>
            <mat-icon
              style="color: rgb(236, 199, 58)"
              aria-hidden="false"
              aria-label="Example home icon"
              fontIcon="local_shipping"
            ></mat-icon>
            <span>En espera de recolección</span>
          </button>
          <button mat-menu-item>
            <mat-icon
              style="color: rgb(236, 199, 58)"
              aria-hidden="false"
              aria-label="Example home icon"
              fontIcon="swap_vert"
            ></mat-icon>
            <span>En espera de cambio de producto</span>
          </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(102, 205, 170)"></mat-icon>
              <span>Aprobado Parcialmente</span>
            </button> 
          </mat-menu>
          <mat-menu #statusERPMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(233, 124, 61)"></mat-icon>
              <span>Pendiente envío a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color:rgb(141, 19, 19)"></mat-icon>
              <span>Error enviando a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Error en ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-up" style="color:rgb(65, 106, 218)"></mat-icon>
              <span>Enviado a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-down" style="color:rgb(236, 199, 58)"></mat-icon>
              <span>Recibido por ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(148, 46, 139)"></mat-icon>
              <span>Mod. pendiente de replicar</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-check" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Creado en ERP</span>
            </button>
          </mat-menu>
          <mat-menu #customerMenu="matMenu">
            <button mat-menu-item>
              <mat-icon style="color: #2e7d32;">person</mat-icon>
              <span>Cliente Eventual</span>
            </button>
            <button mat-menu-item>
              <mat-icon style="color: #1976d2;">person_outline</mat-icon>
              <span>Consumidor Final</span>
            </button>
          </mat-menu>

          <div style="display:inline-flex">
            <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo"
              [disabled]="!(PERMISSIONS.EXPORT_IMPORT | hasPermission)">
              <mat-icon>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                  <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                    font-family="none" font-weight="none" font-size="none" text-anchor="none"
                    style="mix-blend-mode: normal">
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                      </path>
                    </g>
                  </g>
                </svg>
              </mat-icon>
            </button>
            <mat-menu #importMenu="matMenu">
              <button *canPermissionsOnly="PERMISSIONS.EXPORT_IMPORT" mat-menu-item [matMenuTriggerFor]="downloadMenu" matTooltip="Descargar Plantilla">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <button *canPermissionsOnly="PERMISSIONS.EXPORT_IMPORT" mat-menu-item (click)="openFileModal()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span>Importar Archivo</span>
              </button>
            </mat-menu>
            <mat-menu #downloadMenu="matMenu">
              <button *canPermissionsOnly="PERMISSIONS.EXPORT_IMPORT" mat-menu-item (click)="downloadSubRouteTemplate()">
                <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                <span>Carga Limpia</span>
              </button>
              <button *canPermissionsOnly="PERMISSIONS.EXPORT_IMPORT" mat-menu-item (click)="downloadDayTemplate()">
                <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
                <span>Descarga Día</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"  mat-table [dataSource]="dataSource" matSort
            (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
            <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)"
                  style="margin-left: 10px;">
                  <mat-icon class="icon-size-5" [svgIcon]="selectedOrder?._id === element._id
                                          ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="check">
              <th mat-header-cell *matHeaderCellDef class=" text-left first-col">
                <mat-checkbox color="primary" (change)="$event ? masterToggle() : null; onCheckboxChange($event)"
                  [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col">
                <mat-checkbox color="primary" (click)="$event.stopPropagation(); onCheckboxChange($event, element)"
                  (change)="$event ? selection.toggle(element) : null;" [checked]="selection.isSelected(element)"
                  [aria-label]="checkboxLabel(element)"
                  [disabled]="!(validateDataToEdit(element))"
                  >
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <mat-icon *ngIf="element.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle" matTooltip="Anulado"
                  style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ACTIVE" svgIcon="heroicons_solid:check-circle" matTooltip="Activo"
                  style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle" matTooltip="En progreso"
                  style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado"
                  style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle" matTooltip="Rechazado"
                  style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="mat_solid:checklist_rtl" matTooltip="Entregado completamente al cliente"
                  style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_PARTIAL_DELIVERED" svgIcon="mat_solid:check" matTooltip="Entregado parcialmente al cliente"
                  style="color: rgb(255, 136, 0); cursor: pointer"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERY_REJECTED" svgIcon="mat_solid:indeterminate_check_box"
                  matTooltip="No entregado al cliente" style="color: rgb(255, 55, 0); cursor: pointer"></mat-icon>
                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_PARTIAL_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado Parcialmente"
                  style="color: rgb(102, 205, 170); cursor: pointer"></mat-icon>
                <!--<mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="heroicons_solid:check-circle" matTooltip="Pedido Finalizado" style="color:rgb(9, 133, 50)"></mat-icon>-->
              </td>
            </ng-container>
            <ng-container matColumnDef="statusERP">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING || !(element.statusERP)" svgIcon="heroicons_solid:clock"
                  matTooltip="Pendiente envío a ERP" style="color:rgb(233, 124, 61); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up"
                  matTooltip="Enviado a ERP" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_RECEIVED" svgIcon="heroicons_solid:document-arrow-down"
                  matTooltip="Recibido por ERP" style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check"
                  matTooltip="Creado en ERP" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR" svgIcon="heroicons_solid:exclamation-triangle"
                  matTooltip="Error enviando a ERP" style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE" svgIcon="heroicons_solid:clock"
                  matTooltip="Mod. pendiente de replicar" style="color:rgb(148, 46, 139); cursor: pointer;"></mat-icon>
                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP" svgIcon="heroicons_solid:exclamation-triangle"
                  matTooltip="Error en ERP" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
              <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                <span *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'"
                  style="background-color: rgb(40, 101, 141); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                  [matTooltip]="element?.subApplication?.name">
                  B
                </span>
                <span *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'"
                  style="background-color: rgb(218, 41, 28); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                  [matTooltip]="element?.subApplication?.name">
                  A
                </span>
                <span *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'"
                  style="background-color: rgb(255, 123, 0); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                  [matTooltip]="'ERP'">
                  E
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="trip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Viaje</th>
              <td mat-cell *matCellDef="let element" class="text-secondary text-center first-col table-text">
                 <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                    (click)="hasTrip(element) && goToTravel(element)"
                    [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                    <span>{{ hasTrip(element) ? element.trip.id : '-' }}</span>
                    <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                      [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                  </div>
              </td>
            </ng-container>
                <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ruta</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="text-left first-col table-text"
                  [matTooltip]="getTooltip(element)"
                  matTooltipClass="info-tooltip"
                  matTooltipShowDelay="300"
                  matTooltipPosition="above"
                >
                  <div class="table-text-m">
                    <!-- Ruta -->
                    <div *ngIf="element.subRoute; else noData">
                      <span class="table-text-code">
                        {{
                          element?.subRoute?.externalKeys?.code ??
                            element?.subRoute?.model
                        }} </span
                      ><br />
                      {{ element?.subRoute?.name }}
                    </div>

                    <!-- Usuario -->
                    <div
                      *ngIf="element?.user?.user_login?.username"
                      class="mt-1"
                    >
                      <strong>Usuario:</strong>
                      {{ element?.user?.user_login?.username }}
                    </div>

                    <!-- Responsable -->
                    <div class="mt-1">
                      <strong 
                       *ngIf="
                          element.responsibleBusinessPartner?.personNumber ||
                          element.responsibleBusinessPartner?.externalKeys
                        "
                      >Respons. :</strong>
                      <span
                        class="table-text-code"
                        *ngIf="
                          element.responsibleBusinessPartner?.personNumber ||
                          element.responsibleBusinessPartner?.externalKeys
                        "
                      >
                        {{
                          element.responsibleBusinessPartner?.personNumber
                            ? element.responsibleBusinessPartner?.personNumber +
                              " - "
                            : ""
                        }}
                        {{
                          element.responsibleBusinessPartner?.externalKeys?.code
                        }} </span
                      ><br *ngIf="element.responsibleBusinessPartner?.name" />
                      {{ element.responsibleBusinessPartner?.name ?? "" }}
                    </div>
                  </div>
                </td>
              </ng-container>
            <ng-container matColumnDef="routeUser">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Ruta - Usuario</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <div class="table-text-m" *ngIf="element.subRoute || element.user; else noData">
                  <app-user-route-display
                    [routeData]="{
                      routeName: element?.subRoute?.name ?? '-',
                      externalKeys: { 
                        code: element?.subRoute?.externalKeys?.code ?? 
                              element?.subRoute?.code ?? '-'
                      }
                    }"
                    [userData]="{
                      name: element?.user?.user_login?.username ?? 
                            element?.user ?? 
                            element?.username ?? '-',
                      username: element?.user?.user_login?.username ?? 
                               element?.username ?? '-'
                    }"
                    [responsibleData]="{
                      name: element?.responsibleName ?? 
                            element?.responsibleBusinessPartner?.name ?? 
                            element?.responsible?.name ??
                            element?.businessPartner?.name ?? '-',
                      personNumber: element?.responsibleBusinessPartner?.personNumber ?? 
                                   element?.responsible?.personNumber ?? '-',
                      externalKeys: { 
                        code: element?.responsibleCode ?? 
                              element?.responsibleBusinessPartner?.externalKeys?.code ?? 
                              element?.responsible?.externalKeys?.code ??
                              element?.responsible?.code ?? '-'
                      }
                    }"
                    [displayMode]="'detailed'"
                    [showRouteCode]="true"
                    [showUser]="true"
                    [showResponsible]="true">
                  </app-user-route-display>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="seller">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                Responsable</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <p class="table-text-m" style="min-width: 102px;">
                  <span class="table-text-code"
                    *ngIf="element.responsibleBusinessPartner?.personNumber || element.responsibleBusinessPartner?.externalKeys">
                    {{element.responsibleBusinessPartner?.personNumber ?
                    element.responsibleBusinessPartner?.personNumber + ' - ': '' }}
                    {{element.responsibleBusinessPartner?.externalKeys?.code}}<br></span>
                  {{ element.responsibleBusinessPartner?.name ?? '-' }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="businessPartner">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Pagador/Receptor
              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <app-business-partner-display
                  [soldTo]="element.soldTo"
                  [shipTo]="element.shipTo"
                  [customerType]="element.shipToType"
                  [showIcons]="true"
                  [compact]="true">
                </app-business-partner-display>
              </td>
            </ng-container>
            <ng-container matColumnDef="documentNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"><span
                  style="text-align: left;">Nro. Doc.</span></th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <p class="table-text-m " style="min-width: 55px;"
                  [ngStyle]="{'color': element?.isOrderWithoutStock ? 'red' : ''}">
                  <span class="table-text-code">{{ element?.serial }}</span><br>
                  {{ element?.externalKeys?.code }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="class">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Clase</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <p class="table-text-m">
                  @if(element.class){
                  <span class="table-text-code" *ngIf="getCode(element.class) as code">
                    {{ code }} <br>
                  </span>
                  }
                  {{ element?.class?.name }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Fecha</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <p class="table-text-m" style="min-width: 90px;">
                  <b>C: </b> {{element?.loadDateTime | FormatDateHour: false }} <br>
                  <b>E: </b> {{element?.deliveryDateTime | FormatDateHour: false }}
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="subTotal">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                <span class="table-text-m-2">SubTotal {{ 'code' | companyCurrency: true }}</span>
              </th>
              <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                <p class="table-text-m-2">
                  {{ (element?.subTotal | decimalFormat) }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="surcharge">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                <span class="table-text-m-2">Recargo {{ 'code' | companyCurrency: true }}</span>
              </th>
              <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                <p class="table-text-m-2">
                  {{ (element?.totalSurcharges | decimalFormat) }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="discount">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                <span class="table-text-m-2">Descuento {{ 'code' | companyCurrency: true }}</span>
              </th>
              <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                <p class="table-text-m-2">
                  {{ (element?.totalDiscounts | decimalFormat) }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="tax">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                <span class="table-text-m-2">Impuesto {{ 'code' | companyCurrency: true }}</span>
              </th>
              <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                <p class="table-text-m-2">
                  {{ (element?.totalTaxes | decimalFormat) }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                <span class="table-text-m-2">Total {{ 'code' | companyCurrency: true }}</span>
              </th>
              <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                <p class="table-text-m-2">
                  {{ (element?.total | decimalFormat) }}
                </p>
              </td>
            </ng-container>
            <ng-container matColumnDef="creation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Creación
              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                {{element?.creationDateTime | FormatDateHour: true }}
              </td>
            </ng-container>
            <ng-container matColumnDef="documentStatus">
              <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">Estado<br>Doc.
              </th>
              <td mat-cell *matCellDef="let element" class="first-col text-right">
                {{ '-' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class=" text-left first-col" style="min-width: 40px;">
                <button *ngIf="selection.selected.length > 0 " mat-icon-button [matMenuTriggerFor]="actionOrder"
                  matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionOrder="matMenu">
                  <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="onUpdateOrder()">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Mover</span>
                  </button>
                </mat-menu>


              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button *ngIf="(PERMISSIONS.UPDATE | hasPermission) && (element?.statusId != StatusEnum.INACTIVE && element?.statusId != StatusEnum.ORDER_APPROVED && element?.statusId != StatusEnum.ORDER_REJECTED)"
                    mat-menu-item (click)="onUpdateOrder(element)" [disabled]="!(
                                      validateDataToEdit(element)
                                    )">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Mover</span>
                  </button>
                  <ng-container *ngIf="(PERMISSIONS.REPRINT | hasPermission)">
                    <app-reprint-button
                      [label]="'Reimprimir'"
                      [element]="element"
                      [typeDocument]="type">
                    </app-reprint-button>
                  </ng-container>
                  <button [disabled]="(!(PERMISSIONS.SYNC | hasPermission)) || (!( validateDataToSynchronize(element) ))" mat-menu-item (click)="synchronizeOrders(element)">
                    <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                    <span>Sincronizar</span>
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.COPY" mat-menu-item (click)="cloneOrder(element, 'copy')" [disabled]="!(
                                      validateDataToCopy(element)
                                    )">
                    <mat-icon svgIcon="heroicons_outline:document-duplicate"></mat-icon>
                    <span>Copiar</span>
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.SPLIT" mat-menu-item (click)="cloneOrder(element, 'divide')" [disabled]="!(
                                      validateDataToDivide(element)
                                    )">
                    <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
                    <span>Dividir</span>
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.VIEW_LOGS" mat-menu-item (click)="openLogModal(element)">
                    <mat-icon>visibility</mat-icon>
                    <span>Visualizar logs</span>
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.VIEW_AUDIT_LOG" mat-menu-item (click)="openAuditLog(element)">
                    <mat-icon>history</mat-icon>
                    <span>Ver log de modificaciones</span>
                  </button>
                  <button *canPermissionsOnly="PERMISSIONS.APPROVE_REJECT" mat-menu-item (click)="openModal(element)"
                    [disabled]="!(validateDataToAppOrRejected(element))">
                    <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                    <span>{{projectName == 'DIUNSA' ? 'Rechazar' : 'Aprobar/Rechazar'}}</span>
                  </button>
                  <app-document-flow-button [disabled]="!(PERMISSIONS.VIEW_FLOW | hasPermission)" [element]="element"></app-document-flow-button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <tr *ngIf="selectedOrder?._id === element._id" class="details-row">
                  <td [attr.colspan]="displayedColumns.length">
                    <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </tr>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900">
            </tr>
            <!-- Fila principal -->
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b"
              [class.table-expanded-row]="selectedOrder?._id === element._id"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no
            hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
    <!-- Modales -->
  </div>
  <ng-template #rowDetailsTemplate let-order>
    <div class="overflow-hidden">
      <div class="flex border-b">
        <form class="flex w-full flex-col">
          <div class="flex flex-col p-3 sm:flex-row">
            <div class="flex flex-auto flex-wrap">
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">Pagador:</div>
                  <div class="cell cell-4">
                    @if (selectedOrder.shipToType) {
                    <span [matTooltip]="selectedOrder.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                    </span>
                    }
                    {{selectedOrder.soldTo?.externalKeys?.code + ' - '}} {{selectedOrder.soldTo?.name}}
                  </div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Destinatario:</div>
                  <div class="cell cell-4">
                    @if (selectedOrder.shipToType) {
                    <span [matTooltip]="selectedOrder.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                    </span>
                    }
                    {{selectedOrder.shipTo?.externalKeys?.code + ' - '}} {{selectedOrder.shipTo?.name}}
                  </div>
                </div>
                @if (selectedOrder.shipToLegalCode) {
                <div class="row">
                  <div class="cell cell-3 table-title">RTN:</div>
                  <div class="cell cell-4">{{ selectedOrder.shipToLegalCode }}</div>
                </div>
                }
                <div class="row">
                  <div class="cell cell-3 table-title">Dirección:</div>
                  <div class="cell cell-4">{{selectedOrder.address?.address }} {{ selectedOrder.address?.postalCode ? '
                    / ' + selectedOrder.address?.postalCode : ' ' }} {{ selectedOrder.address?.contactName ? ' / ' +
                    selectedOrder.address?.contactName : ' ' }} {{ selectedOrder.address?.locationTwo?.name ? ' / ' +
                    selectedOrder.address?.locationTwo?.name : ' ' }} {{ selectedOrder.address?.LocationThree?.name ? '
                    / ' + selectedOrder.address?.LocationThree?.name : ' ' }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Clase de Expedición:</div>
                  <div class="cell cell-4">{{ selectedOrder?.expeditionCondition?.externalKeys?.code }} - {{
                    selectedOrder?.expeditionCondition?.name}}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Condición de Pago:</div>
                  <div class="cell cell-4">{{ selectedOrder?.paymentCondition?.externalKeys?.code }} - {{
                    selectedOrder?.paymentCondition?.name}}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Observaciones:</div>
                  <div class="cell cell-4">{{selectedOrder?.note ?? ' - '}}</div>
                </div>
                <div class="row">
                  <b>Fecha de Carga: </b> {{selectedOrder?.loadDateTime | FormatDateHour: false }}<br>
                </div>
                <div class="row">
                  <b>Fecha de Entrega: </b> {{selectedOrder?.deliveryDateTime | FormatDateHour: false }}
                </div>
              </div>
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">Estado Global:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'GLOBAL') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de rechazo:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'REJECT') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de entrega:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'DELIVERY') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de crédito:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'CREDIT') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de factura:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'INVOICE') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de usuario:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'USER') }}</div>
                </div>
              </div>
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">SubTotal:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.subTotal | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Recargo:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalSurcharges | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Descuento:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalDiscounts | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Impuesto:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalTaxes | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Total:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.total | decimalFormat) }}</div>
                </div>
              </div>
              <div class="flex w-full flex-col">
                <mat-tab-group #tabGroup>
                  <mat-tab label="Entrega">
                    <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                      [dataSource]="dataSourceDetail2" #sortDetail2="matSort" matSort
                      (matSortChange)="sortData($event, 'tab2')">
                      <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          class="px-6 text-left first-col table-tittle">
                          <span style="margin-left: 5px;">Material</span>
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">

                          <div class="flex w-full items-center justify-between gap-2">
                            <p class="table-text-m min-w-0">
                              <span class="table-text-code" *ngIf="getCode(detail.material) as code"> {{code}} <br>
                              </span>
                              <span class="icon-button-container" (mouseenter)="showPopup($event, detail)"
                                (mouseleave)="hidePopupWithDelay()">
                                {{ detail.material?.name }} {{detail?.unitPrice == 0 ? '(P)': ''}}
                              </span>
                            </p>
                            <span class="flex shrink-0 items-center gap-1">
                              <button *ngIf="hasBatches(detail, 'delivered')" mat-icon-button color="primary"
                                  matTooltip="Ver lotes" (click)="openBatchesDetail(detail, 'delivered')">
                                  <mat-icon fontIcon="science"></mat-icon>
                              </button>
                              <app-manual-label-selection-indicator
                                [manuallySelected]="detail.deliveryLabelsManuallySelect === true"
                              ></app-manual-label-selection-indicator>
                            </span>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="warehouse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          class="px-6 text-left first-col table-tittle">Almacén</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <p class="table-text-m">
                            <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code"> {{code}} <br>
                            </span>
                            {{ detail.warehouse?.name }}
                          </p>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="soldQuantity">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">Cantidad
                          (U.M)</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                            <app-unit-measure-display
                              [usedUnit]="{
                              quantity: detail?.soldQuantity,
                              unitId: detail?.soldUnitOfMeasure?._id,
                              unitName: detail?.soldUnitOfMeasure?.name,
                              unitAbbreviation: detail?.soldUnitOfMeasure?.code
                            }"
                              [baseUnit]="{
                                quantity: detail?.baseQuantity,
                                unitId: detail?.baseUnitOfMeasure?._id,
                                unitName: detail?.baseUnitOfMeasure?.name,
                                unitAbbreviation: detail?.baseUnitOfMeasure?.code
                              }"
                              [parallelUnit]="{
                                quantity: detail?.pararellQuantity,
                                unitId: detail?.pararellUnitOfMeasure?._id,
                                unitName: detail?.pararellUnitOfMeasure?.name,
                                unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                              }"
                              [material]="{
                                _id: detail?.material?._id,
                                code: detail?.material?.code,
                                UMPActive: detail?.material?.UMPActive
                              }"
                              [companyUMPActive]="UMPActive"
                              [statusId]="detail.statusId"
                            ></app-unit-measure-display>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="confirmedQuantity">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
                          Cant.<br>Confirmada</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          {{ detail?.stockConfirmedERP ? detail.stockConfirmedERP + ' (' +
                          detail.soldUnitOfMeasure?.name + ')' : '-' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="deliveredQuantity">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
                          Cant.<br>Entregada</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <ng-container
                            *ngIf="detail?.deliveryDocument?.baseQuantity != null || detail?.deliveryDocument?.pararellQuantity != null; else noData">
                            <div *ngIf="detail?.deliveryDocument?.baseQuantity != null">
                              {{ detail.deliveryDocument.baseQuantity | number : '1.3' }} ({{ detail.baseUnitOfMeasure?.name || '' }})
                            </div>
                            <div *ngIf="detail?.deliveryDocument?.pararellQuantity != null">
                              <b>UMP:</b> {{ detail.deliveryDocument.pararellQuantity | number : '1.3' }} ({{ detail.pararellUnitOfMeasure?.name || '' }})
                            </div>
                          </ng-container>
                          <ng-template #noData>-</ng-template>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="relatedDocuments">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle"># Doc.
                          Entrega</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <ng-container *ngIf="detail?.deliveryDocument as doc; else noDelivery">
                            <ng-container *ngIf="doc.serial && doc.externalDocument; else singleOrNone">
                              {{ doc.serial }}<br>{{ doc.externalDocument }}
                            </ng-container>
                            <ng-template #singleOrNone>
                              {{ doc.serial || doc.externalDocument || '-' }}
                            </ng-template>
                          </ng-container>
                          <ng-template #noDelivery>-</ng-template>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail2"
                        class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail2;" class="border-b"></tr>
                    </table>
                  </mat-tab>
                  <mat-tab *ngIf="!selectedOrder.isSamePerson" label="Factura">
                    <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                      [dataSource]="dataSourceDetail3" #sortDetail3="matSort" matSort
                      (matSortChange)="sortData($event, 'tab3')">
                      <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          class="px-6 text-left first-col table-tittle">
                          <span style="margin-left: 5px;">Material</span>
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <div class="flex w-full items-center justify-between gap-2">
                            <p class="table-text-m min-w-0">
                              <span class="table-text-code" *ngIf="getCode(detail.material) as code"> {{code}} <br>
                              </span>
                              {{ detail.material?.name }} {{detail?.unitPrice == 0 ? '(P)': ''}}
                            </p>
                            <span class="flex shrink-0 items-center gap-1">
                              <button *ngIf="hasBatches(detail, 'loaded')" mat-icon-button color="primary"
                                  matTooltip="Ver lotes" (click)="openBatchesDetail(detail, 'loaded')">
                                  <mat-icon fontIcon="science"></mat-icon>
                              </button>
                              <app-manual-label-selection-indicator
                                [manuallySelected]="detail.deliveryLabelsManuallySelect === true"
                              ></app-manual-label-selection-indicator>
                            </span>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="warehouse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                          class="px-6 text-left first-col table-tittle">Almacén</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <p class="table-text-m">
                            <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code"> {{code}} <br>
                            </span>
                            {{ detail.warehouse?.name }}
                          </p>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="soldQuantity">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">Cantidad
                          (U.M)</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <p class="table-text-m-2 pd-l">
                            {{ (detail?.soldQuantity | number : '1.3') }} ({{detail?.soldUnitOfMeasure?.name}}) <br>
                            <app-unit-measure-display
                              [baseUnit]="{
                                quantity: detail?.baseQuantity,
                                unitId: detail?.baseUnitOfMeasure?._id,
                                unitName: detail?.baseUnitOfMeasure?.name,
                                unitAbbreviation: detail?.baseUnitOfMeasure?.code
                              }"
                              [parallelUnit]="{
                                quantity: detail?.pararellQuantity,
                                unitId: detail?.pararellUnitOfMeasure?._id,
                                unitName: detail?.pararellUnitOfMeasure?.name,
                                unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                              }"
                              [material]="{
                                _id: detail?.material?._id,
                                code: detail?.material?.code,
                                UMPActive: detail?.material?.UMPActive
                              }"
                              [companyUMPActive]="UMPActive"
                              [statusId]="detail.statusId"
                            ></app-unit-measure-display>
                          </p>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicedQuantity">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">
                          Cant.<br>Facturada</th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                          <ng-container
                            *ngIf="detail?.invoiceDocument?.baseQuantity != null || detail?.invoiceDocument?.pararellQuantity != null; else noData">
                            <div *ngIf="detail?.invoiceDocument?.baseQuantity != null">
                              {{ detail.invoiceDocument.baseQuantity | number : '1.3' }} ({{ detail.baseUnitOfMeasure?.name || '' }})
                            </div>
                            <div *ngIf="detail?.invoiceDocument?.pararellQuantity != null">
                              <b>UMP:</b> {{ detail.invoiceDocument.pararellQuantity | number : '1.3' }} ({{ detail.pararellUnitOfMeasure?.name || '' }})
                            </div>
                          </ng-container>
                          <ng-template #noData>-</ng-template>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicedPrice">
                        <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-right">
                          Precio<br>Facturado {{ 'code' | companyCurrency: true }}
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                          <span>{{ (detail?.invoiceDocument?.externalPrice | decimalFormat) || '-' }}</span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoicedDiscount">
                        <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-right">
                          Desc.<br>Factura  {{ 'code' | companyCurrency: true }}
                        </th>
                        <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                          <span>{{ (detail?.invoiceDocument?.externalDiscount| decimalFormat) || '-' }}</span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="invoice">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle"><span
                            style="margin-left: 10px;"># Factura</span></th>
                        <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                          <ng-container *ngIf="detail?.invoiceDocument as doc;else noInvoice">
                            <ng-container *ngIf="doc.serial && doc.externalDocument; else singleOrNone">
                              {{ doc.serial }}<br>{{ doc.externalDocument }}
                            </ng-container>
                            <ng-template #singleOrNone>
                              {{ doc.serial || doc.externalDocument || '-' }}
                            </ng-template>
                          </ng-container>
                          <ng-template #noInvoice>-</ng-template>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail3"
                        class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail3;" class="border-b"></tr>
                    </table>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #popupTemplate>
    <div class="popup-container" [ngStyle]="popupStyle">
      <h4>{{ popupText }}</h4>
    </div>
  </ng-template>

  <ng-template #noData>
    <span>
      -
    </span>
  </ng-template>

  <app-filter
    (onFilterEvent)="getList()"
    (onCleanEvent)="clearFilters()"
  >
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true"
        [showEndTrip]="true"></app-dates-filters>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
        [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
      <app-documents-filters [form]="form" [documentClass]="true"
      [typeDocumentClass]="'DocumentTypeEnum.ENTREGA_SALIDA'" [loadData]="loadDocumentsData"
      ></app-documents-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
        [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
      <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
      [loadData]="loadMaterialsData">
      </app-materials-management-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>

<!-- Modal para confirmar actualización de un detalle -->
<ng-template #orderDetailUpdateConfirmationDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar actualización
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea actualizar el detalle?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #fileImportDialog>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Formulario de Carga
  </h2>
  <mat-dialog-content class="modal-content mt-0">
    <mat-tab-group>
      <mat-tab label="Por ruta">
        <div class="grid grid-cols-1 gap-y-2 gap-x-4">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Fecha de Entrega</mat-label>
            <input matInput [(ngModel)]="currentRoute.deliveryDateTime" [matDatepicker]="chargeDatePicker"
              [min]="today()" required>
            <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #chargeDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>Oficina</mat-label>
            <mat-select [(ngModel)]="currentRoute.officeId" name="officeRouteId"
              (selectionChange)="changeSalesOffice('R')" required>
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchSalesOffice" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changueOptionsSalesOffice($event)" placeholderLabel="Buscar ruta..."
                  noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              @for (office of filterSalesOfficeList; track office) {
              <mat-option [value]="office.id">
                <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>Ruta</mat-label>
            <mat-select [(ngModel)]="currentRoute.routeId" name="routeId">
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchRoute" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changueOptionsRoute($event)" placeholderLabel="Buscar ruta..."
                  noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              @for (route of filterRouteList; track route) {
              <mat-option [value]="route.id">
                <b *ngIf="getCode(route) as code">{{ code }} - </b>{{ route.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field class="w-full">
            <mat-label>Punto de Emisión</mat-label>
            <mat-select [(ngModel)]="currentRoute.emissionPointId" name="emissionPointId" required>
                <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchEmissionPoint" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="changueOptionsEmissionPoint($event)" placeholderLabel="Buscar ruta..."
                        noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                </mat-option>
                @for (point of listFilteremissionPointList; track point) {
                <mat-option [value]="point._id">
                    <b *ngIf="getCode(point) as code">{{ code }} - </b>{{ point.name }}
                </mat-option>
                }
            </mat-select>
          </mat-form-field> -->

          <input #my_file style="display: none" type="file" (change)="handleFileInput($event)" accept=".xlsx"
            #hiddenfileinput>
          <div class="uploadfilecontainer" (click)="hiddenfileinput.click()">
            <mat-icon svgIcon="heroicons_outline:arrow-up-tray" color="primary"></mat-icon>
            <span>{{fileToUpload ? fileToUpload.name : 'Importar Archivo'}}</span>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-between">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="warn"
            [disabled]="this.fileToUpload?.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || !(PERMISSIONS.EXPORT_IMPORT | hasPermission)"
            (click)="onConfirmImportFile(hiddenFileInput, 'R')">
            Aceptar
          </button>
        </mat-dialog-actions>
      </mat-tab>

      <mat-tab label="Todo">
        <div class="grid grid-cols-1 gap-y-2 gap-x-4">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Fecha de Entrega</mat-label>
            <input matInput [(ngModel)]="currentAll.deliveryDateTime" [matDatepicker]="chargeDateTPicker"
              [min]="today()" required>
            <mat-datepicker-toggle matIconSuffix [for]="chargeDateTPicker"></mat-datepicker-toggle>
            <mat-datepicker #chargeDateTPicker></mat-datepicker>
          </mat-form-field>

          <input #my_file_all style="display: none" type="file" (change)="handleFileInputAll($event)" accept=".xlsx"
            #hiddenfileinputAll>
          <div class="uploadfilecontainer" (click)="hiddenfileinputAll.click()">
            <mat-icon svgIcon="heroicons_outline:arrow-up-tray" color="primary"></mat-icon>
            <span>{{fileToUploadAll ? fileToUploadAll.name : 'Importar Archivo'}}</span>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-between">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="warn"
            [disabled]="this.fileToUploadAll?.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || !(PERMISSIONS.EXPORT_IMPORT | hasPermission)"
            (click)="onConfirmImportFile(hiddenfileinputAll, 'A')">
            Aceptar
          </button>
        </mat-dialog-actions>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
</ng-template>

<ng-template #fileDayImportDialog>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">
    Descarga Día
  </h2>
  <mat-dialog-content class="modal-content mt-0">
    <div class="grid grid-cols-1 gap-y-2 gap-x-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Fecha</mat-label>
        <input matInput [(ngModel)]="currentDownloadDay.deliveryDateTime" [matDatepicker]="chargeDatePicker"
          required><!--[min]="today()" -->
        <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #chargeDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Oficina</mat-label>
        <mat-select [(ngModel)]="currentDownloadDay.officeId" name="officeId" (selectionChange)="changeSalesOffice('D')"
          required>
          <mat-option>
            <ngx-mat-select-search [(ngModel)]="searchSalesOffice" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="changueOptionsSalesOffice($event)" placeholderLabel="Buscar ruta..."
              noEntriesFoundLabel="No se encontraron resultados">
            </ngx-mat-select-search>
          </mat-option>
          @for (office of filterSalesOfficeList; track office) {
          <mat-option [value]="office.id">
            <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Ruta</mat-label>
        <mat-select [(ngModel)]="currentDownloadDay.routeId" name="routeId">
          <mat-option>
            <ngx-mat-select-search [(ngModel)]="searchRoute" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="changueOptionsRoute($event)" placeholderLabel="Buscar ruta..."
              noEntriesFoundLabel="No se encontraron resultados">
            </ngx-mat-select-search>
          </mat-option>
          @for (route of filterRouteList; track route) {
          <mat-option [value]="route.id">
            <b *ngIf="getCode(route) as code">{{ code }} - </b>{{ route.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-between">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button mat-raised-button color="warn"
        [disabled]="!currentDownloadDay.deliveryDateTime || !currentDownloadDay.officeId || !(PERMISSIONS.EXPORT_IMPORT | hasPermission)" (click)="fetchDownloadDay()">
        Descargar
      </button>
    </mat-dialog-actions>
  </mat-dialog-content>
</ng-template>
